import axios from '../../../configs/axios';

export default {
  fetchReports(params) {
    return axios.post('/research_library/data', { research_library: params });
  },
  updateTickers(params) {
    return axios.post('/profile/email_preferences/batch_tickers_update', params);
  },
};
